import { useCurrentWorkspace } from "src/api/queries";
import { useCapabilities } from "src/hooks/useCapabilities";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";

type LiveAnalyticsAccess = {
  canAccess: boolean;
  isLoading: boolean;
};

type LiveAnalyticsConfigFlag = {
  isEnabled: boolean;
  isLoading: boolean;
};

export const useLiveAnalyticsConfigFlag = (): LiveAnalyticsConfigFlag => {
  const { data: workspace, isLoading } = useCurrentWorkspace();
  return {
    isEnabled:
      isFeatureFlagEnabled(FEATURE_FLAGS.liveAnalytics) ||
      Boolean(workspace?.config?.enable_live_analytics),
    isLoading,
  };
};

// Live Analytics requires the workspace entitlement (the `enable_live_analytics`
// workspace config flag, or the frontend feature flag in dev/preview) AND at
// least an editor workspace role. While loading, access is denied — the role
// can be stale from the previous workspace during a workspace switch.
export const useLiveAnalyticsAccess = (): LiveAnalyticsAccess => {
  const { isEnabled, isLoading: isWorkspaceLoading } =
    useLiveAnalyticsConfigFlag();
  const { liveAnalytics, isLoading: isRoleLoading } = useCapabilities();
  const isLoading = isWorkspaceLoading || isRoleLoading;
  return {
    canAccess: !isLoading && isEnabled && liveAnalytics.canAccess,
    isLoading,
  };
};
